<template>
  <yandex-map-clusterer
    v-model="clusterer"
    zoom-on-cluster-click
    :grid-size="80"
  >
    <slot>
      <yandex-map-marker
        v-for="(marker, index) of markers"
        :key="marker.guid || index"
        :settings="{
                coordinates: marker.coordinates,
                onClick: () => onMarkerClick(marker, index),
                zIndex: openMarker === index ? 1 : 0,
                hideOutsideViewport: true
              }"
      >
        <div class="marker-icon">
          <slot name="marker-icon">
            <vz-icon
              :url="getMarkerIcon(marker)"
              size="40"
              class="marker-icon-default"
            />
            <div v-if="isTooltipOpen(index, marker)" class="marker-icon-tooltip">
              <span>{{ marker.address }}</span>
              <vz-icon
                name="close"
                class="vz-cursor-pointer"
                @click="showTooltip = false"
              />
            </div>
          </slot>
        </div>
      </yandex-map-marker>
    </slot>
    <template #cluster="{ length }">
      <div class="cluster-icon">
        <slot name="cluster-icon">
          <div class="cluster-icon-default" :class="`cluster-icon-default-${variant}`">
            <span>{{ length }}</span>
          </div>
        </slot>
      </div>
    </template>
  </yandex-map-clusterer>
</template>

<script setup lang="ts">
import {YandexMapClusterer, YandexMapMarker} from 'vue-yandex-maps';
import type {YMapClusterer} from '@yandex/ymaps3-types/packages/clusterer';
import {PropType} from 'vue';
import {UIKitVariants} from '~/types/variants';
import {VzMapMarker} from '~/types/components/vz-yandex-map';

const emit = defineEmits(['marker-click'])

const props = defineProps({
  markers: {
    type: Array as PropType<Array<VzMapMarker>>,
    default: () => []
  },
  variant: {
    type: String as PropType<UIKitVariants|'blue'>,
    default: ''
  },
  hasTooltip: {
    type: Boolean,
    default: false
  },
})

const clusterer = shallowRef<YMapClusterer | null>(null)
const openMarker = ref<null | number>(null)
const showTooltip = ref(true)

function getMarkerIcon(marker: any) {
  return marker.markerIcon || '/svg/marker.svg'
}

function onMarkerClick (marker: any, index: number) {
  openMarker.value = index
  showTooltip.value = true
  emit('marker-click', marker)
}

function isTooltipOpen(index: number, marker: VzMapMarker) {
  if (!showTooltip.value) {
    return false
  }
  return (props.hasTooltip && openMarker.value === index) || marker.showTooltip
}
</script>

<style lang="scss">

</style>
